import React from "react";

const InstituicaoMenu = () => {
  const menuItems = [
    { label: "Apresentação", href: "/instituicao" },
    { label: "Palavras do Presidente", href: "/instituicao/palavra-do-presidente" },
    { label: "Organigrama", href: "/instituicao/organigrama" },
    { label: "Legalidade", href: "/instituicao/legalidade" },
    { label: "Missão, Visão e Valores", href: "/instituicao/missao-visao-valores" },
    { label: "Apoio Social", href: "/instituicao/apoio-social" },
    { label: "Perguntas Frequentes", href: "/instituicao/perguntas-frequentes" },
  ];

  const currentPath = window.location.pathname;
  const [hoveredIdx, setHoveredIdx] = React.useState(null);

  return (
    <nav className="modern-menu shadow rounded-3 p-3 bg-white" aria-label="Menu Instituição">
      <ul className="list-unstyled m-0 p-0">
        {menuItems.map((item, idx) => {
          const isActive = currentPath === item.href;
          const isHovered = hoveredIdx === idx;
          return (
            <li key={item.href}>
              <a
                href={item.href}
                className={`d-flex align-items-center justify-content-between gap-2 py-2 px-2 mb-2 rounded transition f-reg menu-link ${
                  isActive ? "active-menu-item text-success bg-light border border-success" : "text-dark"
                } ${isHovered ? "hovered-menu-item" : ""}`}
                style={{
                  textDecoration: "none",
                  fontWeight: isActive ? "bold" : "normal",
                  boxShadow: isActive || isHovered ? "0 2px 8px rgba(40,167,69,0.08)" : "none",
                  transition: "all 0.2s",
                  position: "relative",
                  outline: isHovered ? "2px solid #28a745" : "none",
                }}
                tabIndex={0}
                onMouseOver={() => setHoveredIdx(idx)}
                onFocus={() => setHoveredIdx(idx)}
                onMouseOut={() => setHoveredIdx(null)}
                onBlur={() => setHoveredIdx(null)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    window.location.href = item.href;
                  }
                  if (e.key === "ArrowDown") {
                    setHoveredIdx((prev) => (prev === menuItems.length - 1 ? 0 : prev + 1));
                  }
                  if (e.key === "ArrowUp") {
                    setHoveredIdx((prev) => (prev === 0 ? menuItems.length - 1 : prev - 1));
                  }
                }}
              >
                <span className="d-flex align-items-center">
                  {isActive && (
                    <span
                      className="active-indicator"
                      style={{
                        display: "inline-block",
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        background: "#28a745",
                        marginRight: 8,
                      }}
                    />
                  )}
                  {item.label}
                </span>
                <i className={`bi bi-arrow-right${isActive ? "-short" : ""} text-success`} />
              </a>
            </li>
          );
        })}
      </ul>

      <style>{`
        .modern-menu .menu-link:hover,
        .modern-menu .hovered-menu-item {
          background: #e9f7ef;
          color: #218838 !important;
          transform: translateX(4px) scale(1.02);
          box-shadow: 0 2px 8px rgba(40,167,69,0.08);
        }
        .modern-menu .active-menu-item {
          border-left: 4px solid #28a745;
          background: #e9f7ef;
        }
        .modern-menu .active-indicator {
          animation: popIn 0.2s;
        }
        @keyframes popIn {
          from { transform: scale(0); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </nav>
  );
};

export default InstituicaoMenu;
